var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticStyle:{"font-size":"1.5em"}},[_c('a-icon',{attrs:{"type":"gift"}}),_vm._v(" Affiliate Programs "),_c('small',[_vm._v("(coming soon)")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }